import Programs from "../components/Programs";


const ProgramsScreen = () => {
  return <Programs />;
};
export default ProgramsScreen;
